export const hasRepeatedVerificationRequiredMessage = (accountStatuses) =>
  accountStatuses.repeatedVerificationRequired &&
  accountStatuses.isPassportVerifiedByRisk &&
  !accountStatuses.isAdditionalInformationRequired &&
  !accountStatuses.isPassportInVerification;
